import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GenericCrudService} from '@gatewee/services/generic-crud.service';
import {FeeSnapshot, FeeSnapshotItem} from '@gatewee/types/fee';

@Injectable({
  providedIn: 'root',
})
export class FeesService extends GenericCrudService<FeeSnapshot> {
  constructor(public override http: HttpClient) {
    super('/fees/recipient', http);
  }

  findDefaultFees(): Observable<FeeSnapshotItem[]> {
    return this.http.get<FeeSnapshotItem[]>(this.baseUrl + '/default').pipe();
  }

  findFeeSnapshot(id: number): Observable<FeeSnapshot> {
    return this.http.get<FeeSnapshot>(this.baseUrl + '/snapshot/' + id).pipe();
  }

  /** Effective fees for the logged-in recipient (pre-merged domain + recipient). */
  findFeeSnapshotRecipient(): Observable<FeeSnapshotItem[]> {
    return this.http.get<FeeSnapshotItem[]>(this.baseUrl + '/snapshot').pipe();
  }
}
